import { render, staticRenderFns } from "./provideOrganizationInfoFifth.vue?vue&type=template&id=3ddaca53&scoped=true&"
import script from "./provideOrganizationInfoFifth.vue?vue&type=script&lang=js&"
export * from "./provideOrganizationInfoFifth.vue?vue&type=script&lang=js&"
import style0 from "./provideOrganizationInfoFifth.vue?vue&type=style&index=0&id=3ddaca53&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddaca53",
  null
  
)

export default component.exports